import { BREAKPOINTS } from 'constants/styled.contants';
import { useAppContext } from 'hooks/useAppContext';
import { useEffect } from 'react';

const useDeviceSize = (addListener = false) => {
  const {
    state: {
      deviceSize: { isMobile, isTablet, isDesktop },
    },
    dispatch,
  } = useAppContext();

  const handleResize = () => {
    const viewportWidth = window.innerWidth;

    if (viewportWidth <= BREAKPOINTS.max.sm && !isMobile) {
      dispatch({ type: 'set_is_mobile' });
      return;
    }

    if (viewportWidth >= BREAKPOINTS.min.md && window.innerWidth <= BREAKPOINTS.max.md && !isTablet) {
      dispatch({ type: 'set_is_tablet' });
      return;
    }

    if (viewportWidth >= BREAKPOINTS.min.lg && !isDesktop) {
      dispatch({ type: 'set_is_desktop' });
    }
  };

  useEffect(() => {
    if (addListener) {
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }
    return undefined;
  }, [isMobile, isTablet, isDesktop]);

  return { isMobile, isTablet, isDesktop };
};

export { useDeviceSize };
